import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SearchFacade,
  SearchBookmarkService,
  SearchViewModel,
  OpportunityResult,
  SkillResult,
  PeopleResult,
  GroupResult,
  RelatedSkillResult,
  FeaturedItemResult,
} from './search-reactive-store';
import { SearchFlagsService } from '@app/search/services';
import { LearningResourceViewModel } from '@app/inputs/models/learning-resource.view-model';
import { ReactiveListVM } from '@dg/shared-rsm';
import { mockMarketplaceFilterData } from './mock-marketplace-filter-data';

@Component({
  selector: 'dgx-search-view',
  templateUrl: './search-view.component.html',
  styleUrls: ['./search-view.component.scss'],
  // TODO: enable when removing showSearchLayoutRedesign/search-layout-redesign LD flag
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchViewComponent implements OnInit {
  public readonly hasError$: Observable<boolean>;

  public readonly skills$: Observable<ReactiveListVM<SkillResult>>;
  public readonly people$: Observable<ReactiveListVM<PeopleResult>>;
  public readonly groups$: Observable<ReactiveListVM<GroupResult>>;
  public readonly relatedSkills$: Observable<
    ReactiveListVM<RelatedSkillResult>
  >;
  public readonly opportunities$: Observable<ReactiveListVM<OpportunityResult>>;
  public readonly endorsedSearch$: Observable<
    ReactiveListVM<LearningResourceViewModel>
  >;
  public readonly featuredItems$: Observable<
    ReactiveListVM<FeaturedItemResult>
  >;

  public readonly showEndorsedContent$: Observable<boolean>;
  public readonly mayLoadEndorsedContent$: Observable<boolean>;

  public readonly vm$: Observable<SearchViewModel>;
  public readonly showSearchBar$: Observable<boolean>;

  public marketplaceSearchFilters = mockMarketplaceFilterData;

  constructor(
    private searchFacade: SearchFacade,
    private searchFlagsService: SearchFlagsService,
    private searchBookmarkService: SearchBookmarkService
  ) {
    // Status streams
    this.hasError$ = this.searchFacade.hasError$;

    // Related data streams (TODO: remove w/showSearchLayoutRedesign/search-layout-redesign LD flag)
    this.skills$ = this.searchFacade.skills$;
    this.people$ = this.searchFacade.people$;
    this.groups$ = this.searchFacade.groups$;
    this.relatedSkills$ = this.searchFacade.relatedSkills$;
    this.opportunities$ = this.searchFacade.opportunities$;
    this.featuredItems$ = this.searchFacade.featuredItems$;

    this.showSearchBar$ = this.searchFacade.showSearchBar$;

    this.endorsedSearch$ = this.searchFacade.endorsedSearch$;
    this.showEndorsedContent$ = this.searchFacade.showEndorsedContent$;
    this.mayLoadEndorsedContent$ = this.searchFacade.mayLoadEndorsedContent$;

    // View model stream (and update url on changes)
    this.vm$ = this.searchFacade.vm$.pipe(this.searchBookmarkService.updateUrl);
  }

  // Since we check against this before the VM initializes we have to access it directly...
  public get showSearchLayoutRedesign(): boolean {
    return this.searchFlagsService.showSearchLayoutRedesign;
  }

  public ngOnInit() {
    // Capture initial URL and update state + auto-search learnings
    this.searchBookmarkService.updateState();
  }
}
